angular.module("listingOverviewModule").component("listingCharges", {
    templateUrl: "listingCharges/listingCharges.html",
    bindings: {
        isCoop: '<',
        isTownhouseHouse: '<',
        askingPrice: '<',
        commonCharges: '<',
        tax: '<',
        monthlyMortgage: '<',
        downpaymentAmount: '<',
        downpaymentPercentage: '<',
        mortgageTerm: '<',
        interestRate: '<',
        buildingTypeId: '<',
        squareFootage: '<'
    },
    controller: ["$timeout", "$element", function($timeout, $element) {
        this.$onInit = function() {
            this.totalCost = this.getTotalCost();
            this.costPerSquareFoot = this.getCostPerSquareFoot();
            this.updateDiagramWidths();
            // this.createChart();
        };

        this.getChartData = function() {
            let data = [];

            if (this.commonCharges > 0) {
                data.push({
                    name: 'Common Charges',
                    y: this.commonCharges,
                    color: '#52A6F2'
                });
            }

            if (this.tax > 0) {
                data.push({
                    name: 'Real Estate Tax',
                    y: this.tax,
                    color: '#1737E5'
                });
            }

            if (this.monthlyMortgage > 0) {
                data.push({
                    name: 'Monthly Mortgage',
                    y: this.monthlyMortgage,
                    color: '#A383ED'
                });
            }

            return data;
        };

        this.getTotalCost = function() {
            // Calculate the total cost by summing charges, tax, and mortgage
            return (this.commonCharges || 0) + (this.tax || 0) + (this.monthlyMortgage || 0);
		};
		
		this.getCommonAndTaxTotal = function() {
			return (this.commonCharges || 0) + (this.tax || 0);
		};


        this.getCostPerSquareFoot = function() {
            // Calculate cost per square foot if square footage is provided
            if (this.squareFootage > 0) {
                return (this.totalCost / this.squareFootage).toFixed(2);
            }
            return null; // Return null if square footage is not available
        };
		this.getCostPerSquareFootCharge = function() {
			if (this.squareFootage > 0 && this.commonCharges > 0) {
				return this.commonCharges / this.squareFootage;
			}
			return 0;
		};

		this.getCostPerSquareFootTax = function() {
			if (this.squareFootage > 0 && this.tax > 0) {
				return this.tax / this.squareFootage;
			}
			return 0;
        };

		this.getCostPerSquareFootTotal = function() {
            return this.getCostPerSquareFootCharge() + this.getCostPerSquareFootTax();
        };
        
        this.updateDiagramWidths = function() {
            const total = this.getTotalCost();
            const mortgageFlex = this.monthlyMortgage > 0 ? (this.monthlyMortgage / total) * 100 : 0;
            const commonFlex = this.commonCharges > 0 ? (this.commonCharges / total) * 100 : 0;
            const taxFlex = this.tax > 0 ? (this.tax / total) * 100 : 0;

            const diagramLine = $element[0].querySelector('.mg-diagram-line');
            diagramLine.querySelector('.mortgage').style.flex = mortgageFlex;
            diagramLine.querySelector('.common').style.flex = commonFlex;
            diagramLine.querySelector('.tax').style.flex = taxFlex;
        };

        // this.createChart = function() {
        //     Highcharts.chart($element[0].querySelector('.chart-container'), {
        //         chart: {
        //             type: 'pie',
        //             height: 250,
        //             width: 250,
        //             backgroundColor: 'transparent',
        //             startAngle: 0,
        //             endAngle: 360
        //         },
        //         title: { text: '' },
        //         credits: { enabled: false },
        //         tooltip: { enabled: false },
        //         plotOptions: {
        //             pie: {
        //                 innerSize: 150,
        //                 dataLabels: {
        //                     enabled: false
        //                 },
        //                 showInLegend: false
        //             }
        //         },
        //         series: [{
        //             name: 'Charges',
        //             data: this.getChartData(),
        //             size: 215
        //         }],
        //         // Custom text in the center
        //         subtitle: {
        //             text: `<div style="text-align:center;color:#000;">
        //                 <span style="font-size:18px;font-weight:bold;">$${this.totalCost.toLocaleString()}</span><br />
        //                 Total Cost /mo<br />
        //                 ${this.costPerSquareFoot ? `<span style="font-size:12px;">$${this.costPerSquareFoot} /ft²/mo</span>` : ''}
        //             </div>`,
        //             useHTML: true,
        //             verticalAlign: 'middle',
        //             y: -12 // Adjust positioning to center vertically
        //         }
        //     });
        // };
    }]
});
